<template>
  <div id="app">
    <!-- <div id="nav">
      <span @click="resetView = true">
        <router-link to="/">Home</router-link>
      </span> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view 
      @send-location="locationLookup"
      @add-feature-to-route="addFeature"
      @remove-feature-from-route="removeFeature"
      @clear-features-from-route="clearFeatures"
      @go-home="goHome"
      @data-loaded="dataLoaded"
    />
    <div id="arcgis-map_div">
      <arcgis-map 
        :configReady="mapConfigReady"
        :mapConfig="mapConfig"
        :checkedLayers="checkedLayers"
        :searchValue="selectedLocation"
        :selectedFeature="selectedFeature"
        :selectionData="selectionData"
        :resetView="resetView"
        :updateFeature="updateVal"
        :externalData="closureData"
        @emit-value='goToClosure'
        @reset-complete='resetComplete'
        @search-complete='lookupComplete'
        @mapclick-complete='clickComplete'
        @feature-update-complete='updateComplete'
      >
      </arcgis-map>
    </div>
  </div>
</template>

<script>
import ArcgisMap from '@/components/ArcgisMap.vue'
import axios from 'axios'

export default {
  components: {
    ArcgisMap
  },
  methods: {
    addFeature: function (info) {
      let index;

      if (info.type === 'closure') {
        index = 0;
      } // if
      else if (info.type === 'detour') {
        index = 2;
      } // else if

      this.selectionData.val[index].data = info.id;
      this.selectionData.val[index+1].data = 1;
      this.updateVal = 2;
    },
    removeFeature: function (info) {
      let index;

      if (info.type === 'closure') {
        index = 0;
      } // if
      else if (info.type === 'detour') {
        index = 2;
      } // else if

      this.selectionData.val[index].data = 0;
      this.selectionData.val[index+1].data = 0;
      this.updateVal = 2;
    },
    clearFeatures: function (info) {
      this.selectionData.val[0].data = 0;
      this.selectionData.val[1].data = 0;
      this.selectionData.val[2].data = 0;
      this.selectionData.val[3].data = 0;
      this.updateVal = 2;
    },
    updateComplete: function () {
      this.updateVal = 0;
    },
    lookupComplete: function () {
      this.selectedLocation = "";
    },
    resetComplete: function () {
      this.resetView = false;
    },
    locationLookup: function (location) {
      this.checkedLayers = ["closuresLayer", "closurePointsLayer", "streetsLayer", "closureDrawingLayer"];
      this.selectedFeature = { field: "ID", value: location, layerId: "closurePointsLayer" };
    },
    clickComplete: function (data) {
      if (data.val.length > 0) {
        let closureID = data.val[0].data;
        this.selectionData = data;
        // if (closureID) {
        //   this.$router.push(`/details/${closureID}`);
        // } // if
      } // if
    },
    goToClosure: function (data) {
      if (data && data.val && data.val.length > 0) {
        this.$router.push(`/details/${data.val[0].data}`);
      }
    },
    goHome: function () {
      this.$router.push(`/`);
      this.checkedLayers = ["closuresLayer", "closurePointsLayer", "streetsLayer"];
      this.resetView = true;
    },
    dataLoaded: function (data) {
      this.closureData = data;
    }
  },
  data: function () {
    return {
      mapConfigReady: false,
      mapConfig: {},
      checkedLayers: ["closuresLayer", "closurePointsLayer", "streetsLayer"],
      selectedLocation: "",
      selectedFeature: {},
      resetView: false,
      selectionData: {},
      closureData: {},
      updateVal: 0
    }
  },
  created: async function () {
    let mapConfig = await axios.get('/arcgis-map.json');
    this.mapConfig = mapConfig.data;
    
    this.mapConfigReady = true;
  }
}
</script>

<style>
body {
  width: 100%;
  height: 100%;
  overflow: auto;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  width: 70%;
  margin: 0 15% 0 15%;
  height: 100%;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

#arcgis-map_div {
  position: relative;
  width: 98%;
  height: 400px;
  margin: 2rem 0 10rem 0;
  background-color: #cccccc;
  border: solid 10px #ededed;
}
</style>
